// extracted by mini-css-extract-plugin
module.exports = {"seller_head":"Seller_seller_head__3q3hN","seller_body":"Seller_seller_body__2CkVO"};